// extracted by mini-css-extract-plugin
export var avatarContainer = "_if-0";
export var avatarTypingWave = "_if-i";
export var gray = "_if-f";
export var green = "_if-c";
export var icon = "_if-9";
export var image = "_if-1";
export var lg = "_if-6";
export var md = "_if-5";
export var presenceDot = "_if-b";
export var red = "_if-d";
export var sm = "_if-4";
export var status = "_if-a";
export var typingDot = "_if-h";
export var typingPill = "_if-g";
export var xl = "_if-7";
export var xs = "_if-3";
export var xxl = "_if-8";
export var xxs = "_if-2";
export var yellow = "_if-e";